export default function CheckBadge({ size = 48 }) {
  return (
    <div className="su-badge" style={{ width: size, height: size }} aria-hidden="true">
      <svg width={size * 0.46} height={size * 0.46} viewBox="0 0 24 24">
        <path d="M5 12l5 5L20 7" fill="none" stroke="#0E1118" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </div>
  );
}
